import { isValid, isToday, subDays, startOfDay } from 'date-fns';

export const startDateValidator = (endDate) => (dateValue) =>
  endDate.value > dateValue ? '' : 'Start date must be before end date.';
export const endDateValidator = (startDate) => (dateValue) =>
  startDate.value < dateValue ? '' : 'End date must be after start date.';
export const issuedDateValidator = () => (dateValue) => isValid(dateValue) ? '' : 'Invalid date.';

export const dateBuilder = (dateValue, srcDate, validator) => {
  if (srcDate.value === dateValue) return srcDate;

  const date = { ...srcDate };

  if (!isValid(dateValue)) {
    date.error = 'Invalid date';
  } else {
    date.error = validator(dateValue);
  }

  if (date.error == '') {
    date.value = dateValue;
  }
  return date;
};

export const calculateStartDate = (endDate, range) => {
  if (isToday(endDate)) {
    return subDays(new Date(endDate), range + 1).getTime();
  }

  return startOfDay(subDays(new Date(endDate), range)).getTime();
};
